<div class="bg">
  <div class="logo pb-5 col-8"><img src="../../assets/images/mylev.png" alt="mylev" [routerLink]="['']"></div>
  <div class="card center">
    <div class="card-body">
      <h3 class="card-title" style="text-align:center">{{register ? 'Регистрирай се' : 'Влез в профила си'}}</h3>
      <form [formGroup]="loginForm" (ngSubmit)="login()" *ngIf="!register; else registerForm">
        <div class="form-group">
          <label>
            <h5>Email:</h5>
          </label>
          <input type="text" required name="email" class="form-control" placeholder="example@example.com"
            formControlName="email" />
          <div id="input-info" class="text-danger" *ngIf="email.invalid">
            Трябва да въведете валиден имейл адрес!
          </div>
          <label class="pt-4">
            <h5>Парола:</h5>
          </label>
          <input type="password" required name="password" class="form-control" formControlName="password"
            placeholder="********" />
          <div id="input-info" class="text-danger" *ngIf="password.invalid">
            Паролата са задължителни!
          </div>
        </div>
        <button class="btn btn-primary" [disabled]="loginForm.invalid" type="submit">Влизам</button>
      </form>
      <footer class="d-flex flex-row-reverse">
        <button class="btn btn-link" (click)="switchRegister()">{{register ? 'Към вписването': 'Регистрирай
          се'}}</button>
      </footer>

      <div *ngFor="let message of messages">
        <div *ngIf="message.isValid == false">
          <div class="alert alert-danger alert-dismissible fade show" role="alert">
            {{message.message}}
            <button (click)="removeErrorObject(message.id)" type="button" class="close" data-dismiss="alert"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div *ngIf="message.isValid == true">
          <div class="alert alert-success alert-dismissible fade show" role="alert">
            {{message.message}}
            <button (click)="removeErrorObject(message.id)" type="button" class="close" data-dismiss="alert"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>

      <ng-template #registerForm>
        <app-register></app-register>
      </ng-template>

    </div>
  </div>
</div>